import PluginOutlet from "discourse/components/plugin-outlet";
import lazyHash from "discourse/helpers/lazy-hash";
import routeAction from "discourse/helpers/route-action";
import CirclesMembershipButton from "../membership-button";

const CircleCardAction = <template>
  <div class="circles-card__actions">
    <PluginOutlet
      @name="circles-card-actions"
      @outletArgs={{lazyHash
        model=@model
        showMembershipButton=@showMembershipButton
      }}
    >
      {{#if @showMembershipButton}}
        <CirclesMembershipButton
          @model={{@model}}
          @showLogin={{routeAction "showLogin"}}
        />
      {{/if}}
    </PluginOutlet>
  </div>
</template>;

export default CircleCardAction;
